import { render } from "./SchedulerSnapshotAccordion.vue?vue&type=template&id=636fa042&scoped=true&ts=true"
import script from "./SchedulerSnapshotAccordion.vue?vue&type=script&lang=ts"
export * from "./SchedulerSnapshotAccordion.vue?vue&type=script&lang=ts"

import "./SchedulerSnapshotAccordion.vue?vue&type=style&index=0&id=636fa042&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636fa042"]])

export default __exports__